export const GOOGLE_API_LIBRARIES = ['places'] as 'places'[];
